import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
} from "reactstrap"
import Select from "react-select"
import { post, del } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from "react-i18next"
import { useNavigate } from "react-router-dom"
import {
  ADD_PAYMENT_STATUS,
  LANGUAGES_SEARCH,
  COUNTRIES_SEARCH,
} from "../../helpers/api_endpoints"

document.title = "Add Payment Status"

function AddPaymentStatus() {
  const [status, setStatus] = useState(1)
  const [name, setName] = useState('{"title":[{"1":""}]}')
  const [symbol, setSymbol] = useState("")
  const [languages, setLanguages] = useState([])
  const [errorMsg, seterrorMsg] = useState([])
  const [loading, setLoading] = useState(false)
  const [valued, setValued] = useState({ title: [] })
  const [countries, setCountries] = useState([])
  const [selectedCountry, setSelectedCountry] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    const getLanguages = async () => {
      setLoading(true)
      try {
        const response = await post(`${LANGUAGES_SEARCH}`, { status: 1 })
        const languages = response.data
        setLanguages(languages)
        setLoading(false)
      } catch (error) {
        console.log(error)
        seterrorMsg(error.message)
      }
    }
    const getCountries = async () => {
      setLoading(true)
      try {
        const response = await post(`${COUNTRIES_SEARCH}`)
        const countries = response.data
        setCountries(
          countries.map(country => ({
            value: country.id,
            label: country.name,
            ...country,
          }))
        )
        setLoading(false)
      } catch (error) {
        console.log(error)
        seterrorMsg(error.message)
      }
    }
    getLanguages()
    getCountries()
  }, [])

  const handleSubmit = () => {
    const config = { name, symbol, status }

    post(ADD_PAYMENT_STATUS, config)
      .then(response => {
        if (response.code == 201) {
          navigate("/payment-statuses", {
            state: { successMsg: "payment-status Added SuccessFully" },
          })
        }
      })
      .catch(error => {
        seterrorMsg("payment-status Creation Failed")
      })
  }

  const handleName = (languageId, value) => {
    const ln = valued.title.filter(el => {
      return Object.keys(el)[0] == languageId
    })

    if (ln == undefined || ln.length < 1) {
      const ob = {}
      ob[languageId] = value
      valued.title.push(ob)
    } else {
      ln[0][languageId] = value
    }
    setName(JSON.stringify(valued))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Payment Status"
            breadcrumbItem="Add Payment Status"
          />
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              handleSubmit()
              return false
            }}
          >
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <Row>
                      {languages.map((language, index) => (
                        <Row key={index}>
                          <div className="form-group col-md-4 mt-2">
                            <Label className="form-label">
                              <Trans>Name ({language.name})</Trans>
                            </Label>
                            <Input
                              name="name"
                              // value={name}
                              className="form-control"
                              placeholder="Enter Name"
                              type="text"
                              onChange={e =>
                                handleName(language.id, e.target.value)
                              }
                              required={
                                language.id == 1 || language.id == 2
                                  ? true
                                  : false
                              }
                            ></Input>
                          </div>
                        </Row>
                      ))}
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Country</Trans>
                        </Label>
                        <Select
                          name="countryId"
                          value={selectedCountry}
                          onChange={setSelectedCountry}
                          options={countries}
                          getOptionValue={option => option.value}
                          getOptionLabel={option => option.name}
                          placeholder="Select Country"
                          isClearable
                          required
                        />
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Status</Trans>
                        </Label>
                        <select
                          className="form-control"
                          onChange={e => setStatus(e.target.value)}
                          required
                        >
                          <option value=""></option>
                          <option value={1} selected={status == 1}>
                            <Trans>Active</Trans>
                          </option>
                          <option value={0} selected={status == 0}>
                            <Trans>Non Active</Trans>
                          </option>
                        </select>
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Symbol</Trans>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Symbol"
                            value={symbol}
                            onChange={e => setSymbol(e.target.value)}
                            required
                          />
                        </Label>
                      </div>
                    </Row>
                    <div className="mt-4">
                      <Button type="submit" color="danger">
                        <Trans>Submit</Trans>
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AddPaymentStatus
